// extracted by mini-css-extract-plugin
export default {"selection":"TargetHighlight-module__selection--+nV4-","comment":"TargetHighlight-module__comment--UX9Df","annotation":"TargetHighlight-module__annotation--9ZM2O"};